module.exports = __webpack_public_path__ + "img/c4.9cd13e80.png";